import React from "react";
import classes from "./styles.module.scss";
import Title from "@/ui/Title";
import Location from "@/assets/Location.svg";
import TimeClock from "@/assets/TimeClock.svg";
import Wallet from "@/assets/Wallet.svg";
import Body from "@/ui/Body";
import Button2 from "../Button2";
import sanitizeHtml from "sanitize-html"; // Import sanitizeHtml
import { fromUnixTime, formatDistance } from "date-fns";
import clsx from "classnames";

const JobCard = ({ item, all_jobs, color_variant = "turquoise" }) => {
  const location = item.categories.find((_item) => _item.name == "Location");
  const sector = item.categories.find((_item) => _item.name == "Sectors");
  const contractType = item.categories.find((_item) => _item.name == "Contract Type");

  function formatAddress() {
    let address = "";
    item.addresses.forEach((line, index) => {
      if (index > 0) address += ", ";
      address += line;
    });
    return address;
  }

  // Sanitize item.description
  const sanitizedDescription = sanitizeHtml(item.description, {
    allowedTags: [],
    allowedAttributes: {},
  });

  return (
    <div className={clsx(classes.card, "border-hover", color_variant)}>
      <p>
        <small>
          <span className="pe-1">Posted </span>
          {all_jobs ? (
            <time
              dangerouslySetInnerHTML={{
                __html: formatDistance(new Date(fromUnixTime(item?.published_at)), new Date(), {
                  addSuffix: true,
                }),
              }}
            />
          ) : (
            <time
              dangerouslySetInnerHTML={{
                __html: formatDistance(new Date(item?.published_at), new Date(), {
                  addSuffix: true,
                }),
              }}
            />
          )}
        </small>
      </p>
      <Title className={classes.job_title} title={item.title} tag="h5" />
      {sector && <div className={clsx(classes.sector, "bg", color_variant)}>{sector?.values[0]?.name}</div>}
      <div className={classes.highlight}>
        <Location width={18} height={18} className={`fill secondary ${classes.icon}`} />
        <div className={classes.value}>{formatAddress()}</div>
      </div>
      <div className={classes.highlight}>
        <TimeClock width={18} height={18} className={`fill secondary ${classes.icon}`} />
        <div className={classes.value}>{item.salary_package}</div>
      </div>
      <div className={classes.highlight}>
        <Wallet width={18} height={18} className={`fill secondary ${classes.icon}`} />
        <div className={classes.value}>{contractType?.values[0]?.name}</div>
      </div>
      <Body className={classes.description} body={sanitizedDescription} />
      <div className={classes.ctas}>
        <Button2
          className={classes.cta}
          display="View job"
          icon={true}
          link={`/jobs/${item.url_slug}`}
          variant={color_variant}
        />
        <Button2
          className={classes.cta}
          display="Apply now"
          icon={true}
          link={`/jobs/${item.url_slug}/#job_application`}
          variant={color_variant}
          outline={true}
        />
      </div>
    </div>
  );
};

export default JobCard;
